import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-white">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-open-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-bold font-heading">韩漫画网</span>
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed max-w-md">
              韩漫画网提供无遮韩国免费漫画大全和免费在线阅读韩漫服务。我们致力于为广大韩漫爱好者打造一个纯净、舒适、便捷的阅读空间，每日更新最新最热门的韩国漫画资源。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(1, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200">全部漫画</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200">关于我们</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200">联系我们</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; {currentYear} 韩漫画网 - 无遮韩国免费漫画大全. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}